import { SnackbarProvider } from 'notistack'
import './Snackbar.css'
import { ReactNode } from 'react'
import SnackbarContext from './SnackbarContext'

export const SnackbarContextProvider = ({ children }: {children: ReactNode}) => {
  return (
    <SnackbarProvider maxSnack={10} anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}>
      <SnackbarContext>
        {children}
      </SnackbarContext>
    </SnackbarProvider>
  );
}

export default SnackbarContextProvider;
